import {
  Activity,
  OrchestratedAgent,
  useGetAgentByThreadIdQuery,
  useGetAgentConfigByIdQuery
} from '../../../generated/types-orchestration'
import { ApolloError } from '@apollo/client'
// import { WorkerAgentConfig } from '@awell/module-types/agents'

interface AgentActivityData {
  orchestrationAgent: OrchestratedAgent | null
  agentConfig: any | null
  loading: boolean
  error: Error | ApolloError | undefined
}

export const useAgentActivityData = (activity: Activity): AgentActivityData => {
  const {
    data: orchestrationAgentData,
    loading: orchestrationAgentLoading,
    error: orchestrationAgentError
  } = useGetAgentByThreadIdQuery({
    variables: {
      id: activity.context?.agent_thread_id
    }
  })

  const {
    data: agentConfig,
    loading: agentConfigLoading,
    error: agentConfigError
  } = useGetAgentConfigByIdQuery({
    variables: {
      id: activity.context?.agent_config_id ?? ''
    }
  })

  return {
    orchestrationAgent: orchestrationAgentData?.getAgentByThreadId?.agent as OrchestratedAgent | null,
    agentConfig: agentConfig?.agent?.workerAgentConfig || null,
    loading: orchestrationAgentLoading || agentConfigLoading,
    error: orchestrationAgentError || agentConfigError
  }
}
